import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EditIcon from "../../../icons/EditSquare.svg";
import DeleteIcon from "../../../icons/Delete.svg";
import TableActions from "./TableActions";
import FormModal from "../Modal/FormModal";
import AddUpdateCountry from "../../pages/Country/AddUpdate";
import { Dropdown, Modal } from "react-bootstrap";
import AddUpdateState from "../../pages/State/AddUpdate";
import CustomPagination from "../CustomPagination";
import "./style.css";
import { ReactComponent as UserSVG } from "../../../images/iconly/UserIcon.svg";
import { projectStatusOptions } from "../../../utils/constant";
import { apiCaller } from "../../../services/AxiosInstance";
import { toast } from "react-toastify";

const Container = ({
  onClick,
  data,
  columns,
  pageSize,
  title,
  isLoading,
  totalPages,
  currentPage,
  total,
  triggerDelete,
  addBtnTitle,
  formModal,
  modalConfig,
  refetchData,
  search,
  searchAudience,
  stats,
  showStats,
  filterIcon = false,
  onRowClick = () => { },
  isEdit,
  isDelete,
  filterOption,
  handleFilters,
  importData,
  FilterComponent,
  secondBtnTitle,
  appliedFilters = [],
  onApplyFilters,
}) => {
  const handleFilterChange = (e) => {
    if (e.target.checked) {
      handleFilters([...filterOption, e.target.value]);
    } else {
      handleFilters(filterOption.filter((item) => item !== e.target.value));
    }

  }
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
    if (refetchData && typeof refetchData === 'function') {
      setTimeout(() => {
        try {
          refetchData();
        } catch (error) {
          console.error("Error refetching data:", error);
        }
      }, 100);
    }
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const [formData, setFormData] = useState(null);
  const [initialValues, setInitialValues] = useState(
    modalConfig?.initialValues ?? null
  );
  const addClick = () => {
    if (formModal) {
      setInitialValues(modalConfig?.initialValues);
      setShowModal(true);
    }
  };
  const showEditModal = (data) => {
    setInitialValues(data);
    setShowModal(true);
  };
  const importxlsvData = () => {

  }
  const [xlxv, setXlxv] = useState(null);
  const [loading, setLoading] = useState(false);
  const [processedCounter, setProcessedCount] = useState(0);
  const [jobId, setJobId] = useState();


  const fetchJobStatus = async () => {
    try {
      let jobKey = importData == "/upload-audiences" ? 'audience-job' : 'project-job';
      let job = localStorage.getItem(jobKey);
      const res = await await apiCaller({
        method: "get",
        url: `jobs/${importData == "/upload-audiences" ? 'audience' : 'projects'}/${job}`,
      });
      console.log("Job status:", res.data);
      if (res.data?.data?.status === "completed") {
        setLoading(false);
        setProcessedCount(0);
        refetchData();
        let jobKey = importData == "/upload-audiences" ? 'audience-job' : 'project-job';
        localStorage.removeItem(jobKey);
        clearInterval(window.jobInterval);
        toast.success("Import Completed");
      } else {
        setProcessedCount(res.data?.data?.processedCount);
      }
    } catch (err) {
      setLoading(false);
      let jobKey = importData == "/upload-audiences" ? 'audience-job' : 'project-job';
      localStorage.removeItem(jobKey);
      clearInterval(window.jobInterval);
      setProcessedCount(0);
      console.error("Job check failed:", err);
    }
  };

  useEffect(() => {
    let jobKey = importData == "/upload-audiences" ? 'audience-job' : 'project-job';
    let job = localStorage.getItem(jobKey);
    if (job) {
      setJobId(job);
      setLoading(true);
      fetchJobStatus();

      const interval = setInterval(() => {
        fetchJobStatus();
      }, 5000);

      window.jobInterval = interval;

      return () => clearInterval(interval);
    }
  }, []);
  const uploadData = async () => {
    if (loading) return false;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", xlxv);

    try {
      const res = await apiCaller({
        method: "post",
        url: importData,
        params: null,
        data: formData,
      });
      if (res?.data?.success) {
        let key = importData == "/upload-audiences" ? 'audience-job' : 'project-job';
        localStorage.setItem(key, res.data.data.jobId);
        setJobId(res.data.data.jobId);
        setLoading(true);
        fetchJobStatus();
        const interval = setInterval(() => {
          fetchJobStatus();
        }, 5000);

        window.jobInterval = interval;
      } else {
        setLoading(false);
      }
      setXlxv(null);
    } catch (err) {
      setLoading(false);
      console.error(err);
      // alert("Error uploading file");
    }
  }
  return (
    <div className="col-12 container-mxw">
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">{title}</h4>
          <div className="d-flex gap-3">
            {search ? (
              <div class="input-group search-area d-xl-inline-flex d-none">
                <button class="input-group-text">
                  <i class="flaticon-381-search-2 text-primary"></i>
                </button>
                <input
                  onChange={(e) => searchAudience(e.target.value)}
                  type="text"
                  class="form-control"
                  placeholder="Search here..."
                />
              </div>
            ) : null}
            {importData ? (
              <button className="me-2 btn add-btn btn-outline-primary d-flex align-items-center text-uppercase" onClick={() => xlxv ? uploadData() : importxlsvData()}>
                {loading ? (
                  <>{processedCounter == 0 ? 'Importing' : `Processed: ${processedCounter} Data`}</>
                ) : (
                  <>
                    {!xlxv ? (
                      <input
                        type="file"
                        accept=".xls,.xlsx,.csv"
                        style={{ position: "absolute", zIndex: 0, opacity: 0, width: "100%", height: "100%", cursor: "pointer" }}
                        onChange={(e) => {
                          if (loading) return false;
                          const file = e.target.files[0];
                          if (file) {
                            setXlxv(file);
                          }
                        }}></input>
                    ) : (
                      <i class="fa-solid fa-file me-3"></i>
                    )}
                    <span>{xlxv ? "Upload" : "Import"}</span>
                  </>
                )}

              </button>
            ) : null}
            {filterIcon ? (
              <FilterComponent
                appliedFilters={appliedFilters}
                onApplyFilters={onApplyFilters}
              />
            ) : null}
            {secondBtnTitle ? (
              <Link to={formModal ? "#" : "add-group"} style={{ zIndex: 2 }} onClick={addClick}>
                <button
                  type="button"
                  class="me-2 btn add-btn btn-outline-primary d-flex align-items-center text-uppercase"
                >
                  <span>{secondBtnTitle}</span>
                  <span class="btn-icon-end">
                    <svg
                      className="add-icon-svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.0001 7.32739V14.6537"
                        // stroke="#BE282D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.6668 10.9904H7.3335"
                        // stroke="#BE282D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.6857 1H6.31429C3.04762 1 1 3.31208 1 6.58516V15.4148C1 18.6879 3.0381 21 6.31429 21H15.6857C18.9619 21 21 18.6879 21 15.4148V6.58516C21 3.31208 18.9619 1 15.6857 1Z"
                        // stroke="#BE282D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </Link>
            ) : null}
            {addBtnTitle ? (
              <Link to={formModal ? "#" : "add"} style={{ zIndex: 2 }} onClick={addClick}>
                <button
                  type="button"
                  class="me-2 btn add-btn btn-outline-primary d-flex align-items-center text-uppercase"
                >
                  <span>{addBtnTitle}</span>
                  <span class="btn-icon-end">
                    <svg
                      className="add-icon-svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.0001 7.32739V14.6537"
                        // stroke="#BE282D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.6668 10.9904H7.3335"
                        // stroke="#BE282D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.6857 1H6.31429C3.04762 1 1 3.31208 1 6.58516V15.4148C1 18.6879 3.0381 21 6.31429 21H15.6857C18.9619 21 21 18.6879 21 15.4148V6.58516C21 3.31208 18.9619 1 15.6857 1Z"
                        // stroke="#BE282D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </button>
              </Link>
            ) : null}
          </div>
        </div>
        {showStats && stats ? (
          <div className="summary-container d-flex justify-content-between mb-1">
            <div className="summary-item">
              {/* <i className="fa fa-user"></i> */}
              <UserSVG />
              <div className="d-flex flex-column">
                <span className="summary-label">Total Users</span>
                <h5 className="summary-number">{stats.totalUsers ?? 0}</h5>
              </div>
            </div>
            <div className="summary-item text-primary">
              {/* <i className="fa fa-user"></i> */}
              <UserSVG />
              <div className="d-flex flex-column">
                <span className="summary-label">Core Team</span>
                <h5 className="summary-number">{stats.coreTeam ?? 0}</h5>
              </div>
            </div>
            <div className="summary-item text-success">
              {/* <i className="fa fa-user"></i> */}
              <UserSVG />
              <div className="d-flex flex-column">
                <span className="summary-label">Mentors</span>
                <h5 className="summary-number">{stats.mentors ?? 0}</h5>
              </div>
            </div>
            <div className="summary-item text-danger">
              {/* <i className="fa fa-user"></i> */}
              <UserSVG />
              <div className="d-flex flex-column">
                <span className="summary-label">Executive Team</span>
                <h5 className="summary-number">{stats.executiveTeam ?? 0}</h5>
              </div>
            </div>
            <div className="summary-item text-info">
              {/* <i className="fa fa-user"></i> */}
              <UserSVG />
              <div className="d-flex flex-column">
                <span className="summary-label">Volunteers</span>
                <h5 className="summary-number">{stats.volunteers ?? 0}</h5>
              </div>
            </div>
          </div>
        ) : null}

        <div className="card-body">
          <div className="w-100 table-responsive">
            {isLoading && (!data || !data?.length <= 0) ? (
              <div>Loading...</div>
            ) : (
              <div id="example_wrapper" className="dataTables_wrapper">
                <table id="example" className="display w-100 dataTable">
                  <thead>
                    <tr role="row">
                      {columns.map((d, i) => (
                        <th key={i}>{d.label}</th>
                      ))}
                      {isEdit || isDelete ? (
                        <th key="actions">Actions</th>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    {!data || data?.length <= 0 ? (
                      <tr>
                        <td colSpan={columns?.length} className="text-center">
                          {title?.toLowerCase() === "audience"
                            ? "Search with Mobile Number or Ticket ID"
                            : "No Data Found"}
                        </td>
                      </tr>
                    ) : (
                      data?.map((d, i) => (
                        <tr key={i} onClick={() => onRowClick(d._id, d)}>
                          {columns.map((columnData, j) =>
                            columnData?.render ? (
                              <td className={j == 0 ? "fixed-col" : ""}>
                                {columnData.render(d, i, currentPage, pageSize)}
                              </td>
                            ) : (
                              <td>{d[columnData.key] ?? "-"}</td>
                            )
                          )}
                          <td
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            {isEdit || isDelete ? (
                              <TableActions
                                triggerDelete={triggerDelete}
                                formModal={formModal}
                                setShowModal={showEditModal}
                                d={d}
                                i={i}
                                refetchData={refetchData}
                                tableName={title.toLowerCase()}
                                isEdit={isEdit}
                                isDelete={isDelete}
                              />
                            ) : null}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                {totalPages > 0 ? (
                  <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                    <div className="dataTables_info">
                      Showing {(currentPage - 1) * pageSize + 1} to{" "}
                      {totalPages > currentPage
                        ? currentPage * pageSize
                        : total}{" "}
                      of {total} entries
                    </div>
                    <CustomPagination
                      total={total}
                      currentPage={currentPage}
                      pageSize={pageSize}
                      onClick={onClick}
                    />
                    {/* <div
                      className="dataTables_paginate paging_simple_numbers"
                      id="example5_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        //   to="/table-datatable-basic"
                        onClick={() =>
                          currentPage > 1 && onClick(currentPage - 1)
                        }
                      >
                        <i
                          className="fa fa-angle-double-left"
                          aria-hidden="true"
                        ></i>
                      </Link>
                      <span>
                        {Array.from({ length: totalPages }).map((_, i) => (
                          <Link
                            key={i + 1}
                            //   to="/table-datatable-basic"
                            className={`paginate_button  ${
                              currentPage === i + 1 ? "current" : ""
                            } `}
                            onClick={() => onClick(i + 1)}
                          >
                            {i + 1}
                          </Link>
                        ))}
                      </span>
                      <Link
                        className="paginate_button next"
                        //   to="/table-datatable-basic"
                        onClick={() =>
                          currentPage < totalPages && onClick(currentPage + 1)
                        }
                      >
                        <i
                          className="fa fa-angle-double-right"
                          aria-hidden="true"
                        ></i>
                      </Link>
                    </div> */}
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
      {showModal && initialValues ? (
        <FormModal
          modalConfig={{
            ...modalConfig,
            initialValues,
            showModal,
            setShowModal,
            closeModal,
            handleCloseModal,
          }}
        />
      ) : null}
    </div>
  );
};

export default Container;
